import React from "react";
import getSize from "../../../utils/getSize";
import css from './index.css';
import NHFetch from "../../../utils/NHFetch";
import BdqkcxTab_Czxy from "./bdqkcxTab_czxy";
import BdqlcxTab_Jx from "./bdqkcxTab_Jx";


const baseUrlPath = "/swbl/lstd"; //基础路径
class BdqkcxTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["bdqkcx"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "czxy") {
                          return <BdqkcxTab_Czxy/>
                      } else {
                          return <BdqlcxTab_Jx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <BdqlcxTab_Jx/>}
          </div>
        );
    }
}

export default BdqkcxTab;



// WEBPACK FOOTER //
// ./components/tjcx/bdqkcx/bdqkcxTab.js